/**
 * 当前项目从node侧直接导流过来，会自动携带用户基础信息，因此应在页面渲染前将数据全部埋下
 */

import { getQueryString, removeQueryByKeys } from '@common/utils/common';
import { cookieSetUser } from '@common/stores/cookie';

const VTOKEN_KEY = 'vtoken';
// const VCODE_KEY = 'vcode';

// url不会传入vtoken，只会传入vcode TODO
const _vtokenString = getQueryString(VTOKEN_KEY);
if (_vtokenString) {
  cookieSetUser(_vtokenString);
}
// removeQueryByKeys(VTOKEN_KEY, VCODE_KEY);
